<div class="max-w-full mx-auto animate-fade-down rounded-2xl" #card >
    <div class="border-primary rounded-2xl border-2 overflow-hidden">

    <!-- Kortti -->
    <div class="bg-white flex flex-col lg:flex-row overflow-visible group/product-card  transition duration-300 ease-in-out">

      <!-- Ensimmäinen kaistale -->
      <div class="bg-primary-100 p-4 flex flex-row lg:flex-col items-center justify-between w-full md:w-full lg:w-[4%] group-hover/product-card:bg-primary-200 transition-colors duration-300 ease-in-out">
        <div class="flex flex-row lg:flex-col gap-2 items-center">
            <div class="text-zinc-600 text-normal font-bold tracking-tight">#{{lamelarea().order | leadingZero }}</div>
            <!--<button class="mt-2 text-gray-400" onclick="navigator.clipboard.writeText('#1234')">
                <svg width="35" height="34" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_2016_9918" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
                    <path d="M1 0.5H0.5V1V17V17.5H1H5H5.5V17V4.61111H17H17.5V4.11111V1V0.5H17H1Z" fill="#D9D9D9"/>
                    <path d="M1 0.5H0.5V1V17V17.5H1H5H5.5V17V4.61111H17H17.5V4.11111V1V0.5H17H1Z" stroke="#606060"/>
                    <path d="M1 0.5H0.5V1V17V17.5H1H5H5.5V17V4.61111H17H17.5V4.11111V1V0.5H17H1Z" stroke="white"/>
                    </mask>
                    <g mask="url(#mask0_2016_9918)">
                    <path d="M0.611328 0.611115H17.3891V16.5H0.611328V0.611115Z" fill="#D9D9D9" stroke="#606060"/>
                    </g>
                    <rect x="7.72168" y="6.8335" width="16.7778" height="15.8889" fill="#D9D9D9" stroke="#606060"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.6979 13.3681L14.6979 10H17.0806V13.3681H21V15.7508H17.0806V19.418H14.6979L14.6979 15.7508H11V13.3681H14.6979Z" fill="#606060"/>
                    </svg>
            </button>-->
        </div>

        <div class="animate-infinite hover:animate-wiggle-more">
            @if (!isLastLamellaArea()){
                <button (click)="removeLamelarea()" type="button" data-cy="remove-lamella-area">
                    <svg class="" width="31" height="34" viewBox="0 0 31 34" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <rect width="31" height="34" fill="url(#pattern0_2016_9917)"/>
                        <defs>
                            <pattern id="pattern0_2016_9917" patternContentUnits="objectBoundingBox" width="1" height="1">
                                <use xlink:href="#image0_2016_9917" transform="matrix(0.01 0 0 0.00875 0 0.0625)"/>
                            </pattern>
                            <image id="image0_2016_9917" width="100" height="100" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADaklEQVR4nO3dIYwVVxTG8dOGBEQNbUIxYIpoDa0AAwgQxVBEa4opmzDzfXff2yyEBEIC4mFYSMCAaRO2povoIsCAAQGYVrSmNSAAA6I1RQAJm2y4ZMIKEgwNc+ecM3N+yd9uMt/dEbvJu08khBBCCCGEEMJbABwmefl9an7G2z85/G8ATpLMbQTgTByBkcNgHIq9w2AfD4XkDpLHCnex1GG80cUOnmOH699c9qxmqzgQ6h9EHAj1x48Dof7gcSDUHzkOhPrDxoFQf0w3B8LX/oz4Lhuw+IGEEEIIIYQQghUA5of6xyKAebGG5OKA/0Xyq1hD8pz2MNTrrFgD4JCBYbJSB8Uakt8ZGCZrVNf1t2INgK3aw1CvLWJNVVWfGhgmazQ9Pb1ODPoAwAvtcdhxzTM3zy4WAXigPRC7775YRfL2AN+QW2IVgAXtgdh9v4hVJOcG+IacEqtIjrQHYvdNi1V1XX9jYKDccXvEqpTSlwYGyl1WVdVmsaqqqo+1B2LHjUajtWIZgKfaI7G7nol1AO4ZGCp31F2xjuRNA0PlLgJwQ6wj+fOADmRerBvYZxAnYl1KqRrQG3JArCO5W3sodlRK6WuxrqqqL7SHYnd9LtaNx+OPDAyVu6h5VvGA5BPtsVg4AP+JFyT/1h6M5ftLvABw3cBguXDXxAuSPxkYLJcMwI/iBYAT2oOxfMfFi5TS/gG8IT+IFyR3aQ/GwqWUdooXVVVt0h6M5ftMvJidnV1N8qWB0XKhXk5NTa0RTwD8a2C4XKh/xJuVj3vlPgbgD/GG5FXt4ViuK+INgAsGhsuFOi/ekDxqYLhcIgBHxBsA+7SHY7m+F29SStt7/IZsE29IbtQejoUajUYbxJvJZLKK5LL2eGy/5ebZxCMAjw0MmFvukXhF8ncDA+Y2A/CbeLXy7Ta5Zy2KVz29/+SseNXT+08Oild9vP+ktnivycDvP9kiXo3H4/UGBsxt1tzpIl5NJpMPSS5pj8j2WmqeSTwj+dDAkLmNmrtcxDsAd7SHZHvdFu9IXurRG7Ig3pE8rT0k22tOvAMwNjBkbqmReEdyr4Ehcxs1d7mId3Vdf6U9JFuquctFvJuZmflEe0i2VHOXi/RBcyeI9ph8/55LX/Tk/pO70hcrtztc9hy6+E7CEEIIIYQQQpDuvQKY6gJLRBYRuAAAAABJRU5ErkJggg=="/>
                        </defs>
                    </svg>
                </button>
            }
        </div>
      </div>
  
      <!-- Toinen ja kolmas kaistale -->
      <div class="flex flex-col md:flex-row w-full">
        <!-- Toinen kaistale -->
          <div class=" p-6 w-full md:w-[30%] lg:w-[45%] flex flex-col items-center space-y-6">
              <app-select class="w-full"  data-cy="select-lamella-set-type"
                          [translate]="true"
                          [options]="availableLamellaAreaSetType"
                          [initialValue]=" lamelarea().lamellaSetType.toString()"
                          (selectedOptionOutput)="updateLamellaSets($event)"
              />
              <div class="border-4 border-gray-300 bg-gray-200 text-gray-400 text-normal w-full h-full">
                  <app-view-port  data-cy="view-port" #viewPort [lamellaArea]="lamelarea()"/>
              </div>
          </div>
  
        <!-- Kolmas kaistale -->
        <div class=" w-full md:w-[70%] lg:w-[70%] flex flex-col">
            <!-- Lamel sets -->
            @for( lamellaSet of lamelarea().lamellaSets; track lamellaSet.id) {
                <app-lamella-set class="mb-1"  data-cy="lamella-set"
                                 [lamellaSet]="lamellaSet"
                                 [lamellaRepeatDisabled]="lamellaRepeatDisabled()"
                />
            }

            <!--Lamel area controls -->
            <div class="p-6 w-full flex flex-col">
                <div class="grid grid-cols-1 lg:grid-cols-4 gap-4 ">
                    <app-card-wrap class="col-span-4 lg:col-span-2" [bgColor]="'white'">
                        <app-card-element [label]="'PRODUCT_CARD.INSTALLATION_DIRECTION' | translate">
                            <app-toggle [toggleState]="lamelarea().orientation !== 'horizontal'"
                                        (toggleStateChange)="orientationChanged($event)"
                                        [leftLabel]="'PRODUCT_CARD.INSTALLATION_DIRECTION_HORIZONTAL' | translate"
                                        [rightLabel]="'PRODUCT_CARD.INSTALLATION_DIRECTION_VERTICAL' | translate"
                                        data-cy="lamella-area-orientation"
                            />
                        </app-card-element>
                    </app-card-wrap>

                    <app-card-wrap class="col-span-4 lg:col-span-2"  [bgColor]="'white'" layout="row">
                        <app-card-element [label]="'PRODUCT_CARD.SPAN_WIDTH' | translate">
                            <app-input [linkedValue]="lamelarea().width"
                                       (valueChange)="onWidthChange($event.value)"
                                       [unit]="'mm'"
                                       data-cy="lamella-area-width"
                            />
                        </app-card-element>
                        <app-card-element [label]="'PRODUCT_CARD.SPAN_HEIGHT' | translate">
                            <app-input [linkedValue]="lamelarea().height"
                                       [unit]="'mm'"
                                       (valueChange)="onHeightChange($event.value)"
                                       data-cy="lamella-area-height"
                            />
                        </app-card-element>
                    </app-card-wrap>

                    <app-card-wrap class="grid grid-cols-1 xl:grid-cols-2"  [colSpan]="4"  [bgColor]="'white'" layout="row">

                        <app-card-element class="" [label]="'PRODUCT_CARD.MOUNTING_PROFILE_CONFIGURATION' | translate">

                            <app-toggle [toggleState]="('product-card.toggle.'+ (lamelarea().automaticFrames ? 'auto': 'manual') ) | translate"
                                        (toggleStateChange)="modeToggle($event)" [leftLabel]="'product-card.toggle.auto' | translate"
                                        [rightLabel]="'product-card.toggle.manual' | translate"
                                        data-cy="lamella-area-mounting-profile"
                            />

                            <app-card-element class="w-full h-20 mt-4" [label]="'PRODUCT_CARD.FRAME_PROFILE' | translate">

                                <app-button-group [translated]="true"
                                                  [options]="frameSelections"
                                                  [linkedValue]="lamelarea()?.frameProfile?.type ?? 'no frame profile'"
                                                  (selected_output)="onFrameProfileChanged($event)"
                                                  data-cy="lamella-area-frame-profile"
                                />

                            </app-card-element>

                            <app-card-element class="w-full h-20 mt-4" [label]="'PRODUCT_CARD.SURFACE_TREATMENT' | translate">

                                <app-button-group [translated]="true"
                                                  [options]="surfaceSelections"
                                                  [linkedValue]="lamelarea()?.mountingProfile?.materialType"
                                                  (selected_output)="onMaterialChanged($event, 'mountingProfile')"
                                                  data-cy="lamella-area-mounting-and-frame-profile-material"
                                />

                            </app-card-element>

                            <app-card-element [label]="'PRODUCT_CARD.MOUNTING_PROFILE_COLOR' | translate ">

                                <app-select #mountingProfileColorRef
                                            [placeholder]="'PRODUCT_CARD.MOUNTING_PROFILE_COLOR_PLACEHOLDER' | translate"
                                            [linkedValue]="lamelarea().mountingProfile.color.RAL"
                                            [showColorIndicator]="true"
                                            data-cy="lamella-area-mounting-and-frame-profile-color">

                                    <ng-template #customContent>
                                        <app-color-selector
                                                (selectedColor)="onColorSelected($event, mountingProfileColorRef, 'mountingProfile')"
                                                (closeModal)="mountingProfileColorRef.close()"
                                                [material]="lamelarea().mountingProfile.materialType === 'Powder Coated' ? 'Powder Coated' : 'Anodized'"
                                                data-cy="lamella-area-mounting-and-frame-profile-material-selector"
                                        ></app-color-selector>
                                    </ng-template>

                                </app-select>

                            </app-card-element>

                        </app-card-element>



                        <!--<app-card-element [label]="'PRODUCT_CARD.COVER_PROFILE' | translate">

                            <app-toggle [toggleState]="hasCoverProfile()"
                                        [leftLabel]="'GLOBAL.NO' | translate"
                                        [rightLabel]="'GLOBAL.YES' | translate"
                                        (click)="toggleCoverProfile()"
                            />

                            <app-card-element class="w-full h-20 mt-4" [label]="'PRODUCT_CARD.COVER_PROFILE_MATERIAL' | translate">

                                <app-button-group [translated]="true"
                                                  [options]="surfaceSelections"
                                                  [linkedValue]="lamelarea().coverProfile?.materialType ? lamelarea().coverProfile.materialType : 'Powder Coated'"
                                                  (selected_output)="onMaterialChanged($event, 'coverProfile')"
                                                  [disabled]="!hasCoverProfile()"

                                />

                            </app-card-element>

                            <app-card-element [label]="'PRODUCT_CARD.COVER_PROFILE_COLOR' | translate">

                                <app-select #coverProfileRef
                                            [placeholder]="'PRODUCT_CARD.COVER_PROFILE_COLOR_PLACEHOLDER' | translate"
                                            [linkedValue]="lamelarea()?.coverProfile?.color?.RAL"
                                            [showColorIndicator]="true"
                                            [disabled]="!hasCoverProfile()"

                                >

                                    <ng-template #customContent>

                                        <app-color-selector (selectedColor)="onColorSelected($event, coverProfileRef, 'coverProfile')"
                                                            (closeModal)="coverProfileRef.close()"
                                        />

                                    </ng-template>

                                </app-select>

                            </app-card-element>

                        </app-card-element>-->



                        <app-card-element [label]="'PRODUCT_CARD.INSTALLATION' | translate " class="xl:col-span-2 mt-4">


                                    <!--
                                    <div class="pt-8 h-auto">
                                        <button role="button" class=" border-2 border-gray-300 p-3 rounded"
                                             [ngClass]="{
                                           'bg-primary-200 hover:bg-primary-200': !showTable,
                                           'hover:bg-primary-50': showTable
                                           }"
                                             (click)="showTable = !showTable">
                                            <svg width="33" height="28.5" viewBox="0 0 33 28.5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0.851769" y="0.587045" width="31.473" height="27.2420" fill="white" stroke="#919191" stroke-width="1.17409"/>
                                                <line x1="0.264725" y1="6.990585" x2="32.9118" y2="6.990585" stroke="#919191" stroke-width="1.17409"/>
                                                <line x1="3.103635" y1="10.481885" x2="8.071665" y2="10.481885" stroke="#919191" stroke-width="1.761135"/>
                                                <line x1="3.103635" y1="23.7468" x2="8.071665" y2="23.7468" stroke="#919191" stroke-width="1.761135"/>
                                                <line x1="13.749345" y1="23.4533" x2="18.7173" y2="23.4533" stroke="#919191" stroke-width="2.348175"/>
                                                <line x1="25.1049" y1="23.4533" x2="30.0729" y2="23.4533" stroke="#919191" stroke-width="2.348175"/>
                                                <line x1="3.103635" y1="17.1162" x2="8.071665" y2="17.1162" stroke="#919191" stroke-width="1.761135"/>
                                                <line x1="13.749345" y1="10.481885" x2="18.7173" y2="10.481885" stroke="#919191" stroke-width="1.761135"/>
                                                <line x1="13.749345" y1="23.7468" x2="18.7173" y2="23.7468" stroke="#919191" stroke-width="1.761135"/>
                                                <line x1="13.749345" y1="17.1162" x2="18.7173" y2="17.1162" stroke="#919191" stroke-width="1.761135"/>
                                                <line x1="25.1049" y1="10.481885" x2="30.0729" y2="10.481885" stroke="#919191" stroke-width="1.761135"/>
                                                <line x1="25.1049" y1="23.7468" x2="30.0729" y2="23.7468" stroke="#919191" stroke-width="1.761135"/>
                                                <line x1="25.1049" y1="17.1162" x2="30.0729" y2="17.1162" stroke="#919191" stroke-width="1.761135"/>
                                                <line x1="3.103635" y1="3.85527" x2="8.071665" y2="3.85527" stroke="#008FA5" stroke-width="1.761135"/>
                                                <line x1="13.749345" y1="3.85527" x2="18.7173" y2="3.85527" stroke="#008FA5" stroke-width="1.761135"/>
                                                <line x1="25.1049" y1="3.85527" x2="30.0729" y2="3.85527" stroke="#008FA5" stroke-width="1.761135"/>
                                            </svg>
                                        </button>
                                    </div>
                                    -->

                                    <app-assembly-configurator class="w-full" [lamellaArea]="lamelarea()" mode="both" data-cy="lamella-area-assembly-configurator" />

                        </app-card-element>

                    </app-card-wrap>
                </div>
            </div>

        </div>

      </div>
  
    </div>
  </div>
</div>

